import createResource from './createResource';
import { BillingVendor } from './types';

const billingVendorsResource = createResource<BillingVendor>({
  key: 'vendorsecrets',
  url: '/vendorsecrets',
  hasFetchBulkSupport: true,
});

export default billingVendorsResource;
